import type { CommodityDetail } from '../../../mocks/commodities';

interface Props {
  commodity: CommodityDetail;
}

export default function CommodityProducts({ commodity }: Props) {
  return (
    <section className="bg-[#f8f6f2] py-20 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto">

        <div className="mb-12">
          <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-3">
            Products &amp; Instruments
          </p>
          <h2 className="text-[#071525] text-3xl md:text-4xl font-bold leading-tight max-w-xl">
            What We Trade Within This Category
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#071525]/10 rounded-xl overflow-hidden border border-[#071525]/10">
          {commodity.products.map((product, i) => (
            <div
              key={product.name}
              className="bg-[#f8f6f2] hover:bg-white transition-colors duration-300 p-8 flex flex-col gap-4 group"
            >
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#d4571a]/15 flex-shrink-0 mt-0.5">
                  <span className="text-[#d4571a] text-xs font-bold">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
                <div>
                  <h3 className="text-[#071525] text-base font-bold mb-2 leading-snug group-hover:text-[#d4571a] transition-colors duration-200">
                    {product.name}
                  </h3>
                  <p className="text-[#071525]/55 text-sm leading-relaxed">
                    {product.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
